import { OrderRepository } from '../../../src/internal/repositories/OrderRepository';
import { EncryptedOrderNumberDataType, OrderApiResponseCode } from '../../api/OrderTrackingApiSdk';
import { emit, events } from '@estee/elc-service-bus';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ErrorMessageType } from '../utils/Constants';

export class OrderTrackingSubmittedUseCase {
    private orderRepository: OrderRepository;
    private encryptedOrderNumberData: EncryptedOrderNumberDataType | undefined;

    constructor(encryptedOrderNumberData?: EncryptedOrderNumberDataType) {
        this.orderRepository = diContainer.get(serviceNames.orderRepository);
        this.encryptedOrderNumberData = encryptedOrderNumberData;
    }

    public execute = async () => {
        const {
            queryOrderNumber,
            setIsLoading,
            setErrorMessageType,
            setQueryOrderNumber
        } = this.orderRepository.orderTracking;

        queryOrderNumber &&
            emit(events.ORDER_TRACKING_SUBMITTED, {
                orderNumber: queryOrderNumber
            });

        setIsLoading(true);
        const { responseCode, orderInfo } = await this.orderRepository.getOrderTrackingData(
            this.encryptedOrderNumberData || queryOrderNumber
        );
        setIsLoading(false);

        switch (responseCode) {
            case OrderApiResponseCode.NOT_FOUND:
                setErrorMessageType(ErrorMessageType.ORDER_NOT_FOUND);
                queryOrderNumber &&
                    emit(events.ORDER_TRACKING_INVALID_NUMBER, {
                        orderNumber: queryOrderNumber
                    });
                break;
            case OrderApiResponseCode.INVALID_ORDER_NUMBER:
                setErrorMessageType(ErrorMessageType.ORDER_NUMBER_INVALID);
                queryOrderNumber &&
                    emit(events.ORDER_TRACKING_INVALID_NUMBER, {
                        orderNumber: queryOrderNumber
                    });
                break;
            case OrderApiResponseCode.GENERIC_ERROR:
                setErrorMessageType(ErrorMessageType.GENERIC);
                break;
            case OrderApiResponseCode.FORBIDDEN:
                setErrorMessageType(ErrorMessageType.TRACK_MY_ORDER_IS_NOT_AVAILABLE);
                break;
            default:
                setQueryOrderNumber('');
                queryOrderNumber && emit(events.ORDER_TRACKING_SUCCESSFUL);
        }

        return orderInfo;
    };
}
